import React from 'react';
import Search from './Search';
import emailInfoTab from './emailInfo/EmailInfoTab';
import { SetupPage } from 'areas/shared/pages/setup';
import * as Formatter from 'fw/components/formatter/Formatter';
import * as API from 'modules/app/API';
import * as Help from 'modules/app/Help';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { EmailStatusLabel } from 'areas/shared/controls';

class EmailingLog extends React.Component {
    
    _emailStatusLabelFormatter = ({ value }) => {
        return <EmailStatusLabel emailStatusCode={value} />;
    };

    render() {
        
        let opts = {
            title: "Emailing Log",
            description: "Review e-mails sent by the automatic notification system",
            addPrivilege: false,
            enableExport: true,            
            helpKey: Help.emailingLogHelpKey,
            recentType: "emailingLog",            
            sortField: "createDate",
            sortDirection: "DESC",
            enableColumnSettings: true,
            setupKey: "emailingLog",
            icon: { comp: faEnvelope, color: "#000000" },
            list: {                
                url: API.Emailing.url('/Emails/Search'),                
                rowKey: "emailKey",
                columns: [
                    { key: 'createDate', name: 'Date', width: 150, sortable: true, formatter: Formatter.ClientDateTime, cellClass: "text-center" },
                    { key: 'recipient', name: 'Recipient', sortable: true, cellClass: "text-left" },
                    { key: 'companyName', name: 'Company Name', width: 160, sortable: true, cellClass: "text-left" },
                    { key: 'subject', name: 'Subject', width: 300, sortable: true, cellClass: "text-left" },
                    { key: 'recipientType', name: 'Recipient Type', width: 120, sortable: true, cellClass: "text-left" },
                    { key: 'emailCategory', name: 'Category', width: 95,sortable: true, cellClass: "text-left" },
                    { key: 'emailStatusCode', name: 'Status',  width: 90, sortable: true, cellClass: "text-center", formatter: this._emailStatusLabelFormatter },
					{ key: 'emailClicked', name: 'Clicked',  width: 90, cellClass: "text-center", formatter: Formatter.Check },
					{ key: 'emailOpened', name: 'Opened',  width: 90, cellClass: "text-center", formatter: Formatter.Check },
                ]
            },
            tabs: [                
                { key: "emailInfo", title: "Email Info", comp: emailInfoTab, helpKey: Help.emailingLogInfoHelpKey }
            ]
        };

        opts = Object.assign(opts, this.props);
        
        return (
                <SetupPage {...opts}                    
                    Search={Search} />
        );
    }
}

export default EmailingLog;


// WEBPACK FOOTER //
// ./src/areas/admin/emailingLog/EmailingLog.js